import { Routes } from '@angular/router';

export const locationRoutes: Routes = [
  {
    path: 'real-estate-profile/sales',
    loadChildren: () => import('@rma/public/locations/sales'),
  },
  {
    path: 'real-estate-profile/leasing',
    loadChildren: () => import('@rma/public/locations/leasing'),
  },
  {
    path: 'finance',
    loadChildren: () => import('@rma/public/locations/finance'),
  },
];
